(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);throw new Error("Cannot find module '"+o+"'")}var f=n[o]={exports:{}};t[o][0].call(f.exports,function(e){var n=t[o][1][e];return s(n?n:e)},f,f.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
var debounce;

debounce = function(fn, delay) {
  var timeoutID;
  timeoutID = null;
  return function() {
    var args, that;
    clearTimeout(timeoutID);
    args = arguments;
    that = this;
    timeoutID = setTimeout((function() {
      fn.apply(that, args);
    }), delay);
  };
};

module.exports = {
  init: function() {
    var app, self;
    self = this;
    if (typeof VeeValidate !== 'undefined') {
      Vue.use(VeeValidate);
    }
    if (typeof window['vue-phone-number-input'] !== 'undefined') {
      Vue.component('vue-phone-number-input', window['vue-phone-number-input']);
    }
    Vue.config.devtools = true;
    return app = new Vue({
      el: '#app',
      delimiters: ['[[', ']]'],
      data: {
        cart: cart,
        cartPopup: false,
        newsletterPopup: false,
        cookiePopup: false,
        chartPopup: false,
        forgottenPopup: false,
        addressPopup: null,
        search: false,
        menuPopup: false,
        megaOn: false,
        country: '',
        countryPopup: false,
        externalPopup: '',
        textPopup: '',
        pagePopup: '',
        freebiePopup: '',
        welcomePopup: false,
        skipPopup: null,
        paymentPopup: null,
        viewCart: false,
        scroller: {},
        global: {
          discount: global_discount,
          rate: 1 - global_discount_rate,
          restrict: global_discount_restrict
        },
        market: 'US',
        searchText: '',
        productSuggestions: []
      },
      mounted: function() {
        var Scrollbar, aff, affdata, eu, fixedAddToCart, header, scroll, scrollWrapper, topbar, url, url_params, vh, wp;
        self = this;
        scroll = document.body.scrollTop || document.documentElement.scrollTop;
        header = document.querySelector('header');
        topbar = document.querySelector('header .top');
        scrollWrapper = document.querySelector('.scroll-wrapper');
        this.stick = {};
        this.$nextTick(function() {
          var fix;
          this.stick = {
            el: document.querySelector('.sticky')
          };
          if (this.stick.el) {
            fix = document.querySelector('.__items') ? 120 : 150;
            this.stick.top = this.stick.el.getBoundingClientRect().top - fix;
            return this.stick.height = this.stick.el.getBoundingClientRect().height;
          }
        });
        setTimeout(function() {
          if (document.querySelector('.sticky2')) {
            self.stick.el2 = document.querySelector('.sticky2');
            self.stick.top2 = self.stick.el2.getBoundingClientRect().top - 150;
            return self.stick.container2 = document.querySelector('.sticky-container').getBoundingClientRect().top - 150 + document.querySelector('.sticky-container').getBoundingClientRect().height;
          }
        }, 500);
        if (document.querySelector('main') !== null) {
          document.querySelector('main').style.paddingTop = header.getBoundingClientRect().height + 'px';
        }
        wp = new WayPointer();
        Scrollbar = window.Scrollbar;
        Scrollbar.use(ModalPlugin);
        document.querySelectorAll('.sider .inside').forEach(function(el) {
          return Scrollbar.init(el, {
            alwaysShowTracks: true
          });
        });
        this.scroller = Scrollbar.init(scrollWrapper, {
          alwaysShowTracks: true
        });
        this.$nextTick(function() {
          return document.addEventListener('mouseover', function(e) {
            if (e.target.closest('.country-selector__list')) {
              return self.scroller.updatePluginOptions('modal', {
                open: true
              });
            } else {
              return self.scroller.updatePluginOptions('modal', {
                open: false
              });
            }
          });
        });
        fixedAddToCart = document.querySelector('.add-to-cart.fixed');
        if (fixedAddToCart) {
          fixedAddToCart.style.top = (window.innerHeight - 80) + 'px';
        }
        this.scroller.addListener(function(status) {
          wp.update(status.offset.y);
          if (fixedAddToCart) {
            if (status.offset.y > (window.innerHeight / 2)) {
              document.querySelector('body').classList.add('show-add');
            } else {
              document.querySelector('body').classList.remove('show-add');
            }
            fixedAddToCart.style.top = (status.offset.y + window.innerHeight - 80) + 'px';
          }
          if (status.offset.y > 50) {
            header.classList.add('scroll');
            scrollWrapper.classList.add('scrolls');
            if (topbar) {
              topbar.style.marginTop = '-' + topbar.getBoundingClientRect().height + 'px';
            }
          } else {
            header.classList.remove('scroll');
            scrollWrapper.classList.remove('scrolls');
            if (topbar) {
              topbar.style.marginTop = 0;
            }
          }
          return self.$nextTick(function() {
            if (self.stick && self.stick.el) {
              if (status.offset.y > self.stick.top) {
                if (status.offset.y < self.stick.height - self.stick.el.getBoundingClientRect().height) {
                  self.stick.el.classList.add('sticked');
                  self.stick.el.style.top = (status.offset.y - self.stick.top) + 'px';
                }
              } else {
                self.stick.el.classList.remove('sticked');
                self.stick.el.style.top = 0;
              }
            }
            if (self.stick && self.stick.el2) {
              if (status.offset.y >= self.stick.top2) {
                if (status.offset.y < self.stick.container2 - self.stick.el2.getBoundingClientRect().height) {
                  self.stick.el2.classList.add('sticked');
                  return self.stick.el2.style.top = (status.offset.y - self.stick.top2) + 'px';
                }
              } else {
                self.stick.el2.classList.remove('sticked');
                return self.stick.el2.style.top = 0;
              }
            }
          });
        });

        /*
        				if !Cookies.get('newsletter')
        					Cookies.set 'newsletter', 'shown', expires: 7
        					setTimeout(->
        						self.newsletterPopup = true
        					, 5000)
         */
        if (!localStorage.getItem('mbcookie')) {
          self.cookiePopup = true;
        }
        if (localStorage.getItem('mbcountry') === 'shown') {
          localStorage.removeItem('mbcountry');
        }
        if (!localStorage.getItem('mbcountry') || !localStorage.getItem('mbcountry_code')) {
          eu = ['FR', 'AT', 'BE', 'BA', 'BG', 'CY', 'CZ', 'DK', 'EE', 'FI', 'DE', 'GR', 'GP', 'HU', 'IS', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'MC', 'NL', 'NO', 'PL', 'PT', 'RE', 'RO', 'SM', 'RS', 'SK', 'SI', 'ES', 'SE', 'CH', 'VT', 'MQ', 'PF'];
          this.request('https://ipgeolocation.abstractapi.com/v1/?api_key=287f890009da4043a9f39bf69cf9adbf', null, function(res) {
            localStorage.setItem('mbcountry', res.country);
            localStorage.setItem('mbcountry_code', res.country_code);
            if (res.country_code === 'FR' || res.country_code === 'GP' || res.country_code === 'MQ' || res.country_code === 'PF' || res.country_code === 'RE') {
              document.querySelector('footer [name="language_code"]').value = 'fr';
            }
            if (eu.indexOf(res.country_code) > -1) {
              if (currency === 'USD') {
                document.querySelector('footer [name="country_code"]').value = 'FR';
              }
              return document.querySelector('footer #localization_form').submit();
            } else {
              if (currency === 'EUR') {
                document.querySelector('footer [name="country_code"]').value = 'US';
                return document.querySelector('footer #localization_form').submit();
              }
            }
          }, 'GET');
        }
        if (location.href.indexOf('#') > -1) {
          url = location.href.split('#');
          if (url[1] === 'detox') {
            self.scroll('#template--14791080116400__1626437606de33921d');
          } else if (url[1] === 'rejuvenate') {
            self.scroll('#template--14791080116400__1626440718d9d0d826');
          } else if (url[0].indexOf('pages/why-choose-beljanski') > -1) {
            console.log('#' + url[1]);
            self.scroll('#' + url[1]);
          } else {
            this.scroll('[data-' + url[1] + ']');
          }
        }
        document.querySelectorAll('.anchor').forEach(function(el) {
          return el.addEventListener('click', function(e) {
            e.preventDefault();
            return self.scroller.scrollTo(0, document.querySelector('#' + el.href.split('#').pop()).offsetTop - header.getBoundingClientRect().height - 100, 1000);
          });
        });
        document.querySelectorAll('.selector.clickable').forEach(function(el) {
          return el.querySelector('.selected').addEventListener('click', function(e) {
            e.preventDefault();
            return e.target.closest('.selector').classList.toggle('open');
          });
        });
        document.querySelectorAll('.acc h4').forEach(function(el) {
          return el.addEventListener('click', function(e) {
            return e.target.parentElement.classList.toggle('active');
          });
        });
        document.querySelectorAll('a.show-pass').forEach(function(el) {
          return el.addEventListener('click', function(e) {
            e.target.previousElementSibling.type = e.target.previousElementSibling.type === 'password' ? 'text' : 'password';
            return false;
          });
        });
        document.querySelectorAll('section.formulas .inside a').forEach(function(el) {
          return el.addEventListener('click', function(e) {
            var prefix;
            if (e.target.href.indexOf('/pages/') > -1) {
              e.preventDefault();
              if (document.querySelector('#pagePopup .body .loading')) {
                prefix = lang !== 'en' ? '/' + lang : '';
                self.request(e.target.href.replace('.com', '.com' + prefix), null, function(res) {
                  var split1, split2;
                  split1 = res.split('<main>')[1];
                  split2 = split1.split('</main>')[0];
                  return document.querySelector('#pagePopup .body').innerHTML = split2;
                }, 'GET', false);
              }
              return self.pagePopup = e.target.href;
            }
          });
        });
        document.querySelectorAll('.bundle-items--product-hold--title').forEach(function(el) {
          return el.addEventListener('click', function(e) {
            return e.target.parentElement.classList.toggle('is-wrapped');
          });
        });
        document.body.addEventListener('click', function(e) {
          if (e.target.href) {
            if (e.target.href.indexOf('crm.maison') > -1 || e.target.href.indexOf('beljanski.org') > -1 || e.target.href.indexOf('beljanski.info') > -1 || e.target.href.indexOf('youtube.com') > -1 || e.target.href.indexOf('youtu.be') > -1) {
              if (!e.target.closest('.chart-popup') && !e.target.classList.contains('play')) {
                e.preventDefault();
                self.externalPopup = e.target.href;
                false;
              }
            }
            if (e.target.href.indexOf('#on-demand') > -1) {
              if (location.pathname === '/pages/events') {
                e.preventDefault();
                self.scroll('[data-on-demand]');
                false;
              }
            }
            if (e.target.href.indexOf('#detox') > -1) {
              if (location.pathname === '/pages/why-choose-targetage') {
                e.preventDefault();
                self.scroll('#template--14791080116400__1626437606de33921d');
                false;
              }
            }
            if (e.target.href.indexOf('#rejuvenate') > -1) {
              if (location.pathname === '/pages/why-choose-targetage') {
                e.preventDefault();
                self.scroll('#template--14791080116400__1626440718d9d0d826');
                false;
              }
            }
            if (e.target.href.indexOf('why-choose-beljanski#') > -1) {
              if (location.pathname.indexOf('/pages/why-choose-beljanski') > -1) {
                e.preventDefault();
                self.scroll('#' + e.target.href.split('#')[1]);
                false;
              }
            }
            if (e.target.classList.contains('pag-scroll')) {
              self.scroll('.' + e.target.closest('.pagination').parentElement.classList.value);
            }
            if (e.target.classList.contains('btn') && document.querySelector('#aff-form')) {
              if (e.target.href.indexOf('affiliate-program') > -1) {
                e.preventDefault();
                document.querySelector('#aff-form').style.display = 'block';
                return setTimeout(function() {
                  return self.scroll('#aff-form');
                }, 0);
              }
            }
          }
        });
        vh = window.innerHeight * 0.01;
        document.querySelector(':root').style.setProperty('--vh', vh + 'px');
        if (document.querySelector('[data-fslightbox]')) {
          refreshFsLightbox();
        }
        url_params = new URLSearchParams(window.location.search);
        aff = url_params.get('acc');
        if (aff) {
          Cookies.set('mbaffiliate', aff, {
            expires: 365
          });
          affdata = {
            module: 'affiliate',
            action: 'profile/save',
            id: aff,
            click: true
          };
          return this.request('/apps/mm-master', affdata, function(res) {});
        }
      },
      watch: {
        searchText: debounce((function(newVal) {
          this.$root.searchProducts(newVal);
        }), 1000)
      },
      methods: {
        request: function(url, obj, done, method, parse, type) {
          var xhr;
          if (obj == null) {
            obj = null;
          }
          if (method == null) {
            method = 'POST';
          }
          if (parse == null) {
            parse = true;
          }
          if (type == null) {
            type = null;
          }
          xhr = new XMLHttpRequest;
          xhr.open(method, url);
          xhr.onload = function() {
            if (parse) {
              done(JSON.parse(xhr.response));
            } else {
              done(xhr.response);
            }
          };
          xhr.onerror = function() {
            if (parse) {
              done(JSON.parse(xhr.response));
            } else {
              done(xhr.response);
            }
          };
          if (obj) {
            if (obj.form) {
              return xhr.send(obj.form);
            } else {
              obj.lang = lang;
              obj.currency = currency;
              xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
              return xhr.send(JSON.stringify(obj));
            }
          } else {
            return xhr.send();
          }
        },
        formalize: function(form) {
          var data;
          data = new FormData;
          Array.prototype.forEach.call(form.elements, function(el, name) {
            var i, _results;
            if (el.type !== 'submit') {
              if (el.type === 'file') {
                if (el.files.length) {
                  i = 0;
                  _results = [];
                  while (i < el.files.length) {
                    data.append(el.name, el.files[i]);
                    _results.push(i++);
                  }
                  return _results;
                }
              } else if (el.type === 'checkbox') {
                if (el.checked) {
                  return data.append(el.name, el.value);
                }
              } else {
                return data.append(el.name, el.value);
              }
            }
          });
          return data;
        },
        scroll: function(anchor) {
          return this.scroller.scrollIntoView(document.querySelector(anchor), {
            offsetTop: 200
          });
        },
        money: function(price) {
          return Shopify.formatMoney(price);
        },
        updateCart: function() {
          var prefix;
          self = this;
          prefix = lang !== 'en' ? '/' + lang : '';
          return this.$root.request(prefix + '/cart?view=json', null, function(res) {
            return self.cart = res;
          }, 'GET');
        },
        addToCart: function(data) {
          var fine, max, q;
          self = this;
          max = -1;
          q = -1;
          this.cart.items.forEach(function(item) {
            if (parseInt(item.id) === parseInt(data.id)) {
              max = item.max;
              return q = item.q;
            }
          });
          if (max === -1) {
            fine = true;
          } else {
            if (q + data.quantity > max) {
              fine = false;
            } else {
              fine = true;
            }
          }
          if (fine) {
            this.$refs.asuccess.classList.add('active');
            this.viewCart = true;
            setTimeout(function() {
              return self.$refs.asuccess.classList.remove('active');
            }, 5000);
            return this.request('/cart/add.js', data, function() {
              self.updateCart();
              return self.cartPopup = true;
            });
          } else {
            this.$refs.afail.innerText = 'You can not add more of this product';
            this.$refs.afail.classList.add('active');
            return setTimeout(function() {
              return self.$refs.afail.classList.remove('active');
            }, 3000);
          }
        },
        addUpsell: function(id) {
          return this.addToCart({
            id: id,
            quantity: 1
          });
        },
        updateQ: function(id, q, max) {
          var bundle_item_keys;
          self = this;
          bundle_item_keys = [];
          self.cart.items.forEach(function(item) {
            if (item.bundle_keys !== void 0 && item.bundle_keys.includes(id)) {
              return bundle_item_keys = item.bundle_keys;
            }
          });
          if (bundle_item_keys.length) {
            return this.request('/cart/change.js', {
              quantity: q,
              id: bundle_item_keys[0]
            }, function() {
              return self.request('/cart/change.js', {
                quantity: q,
                id: bundle_item_keys[1]
              }, function() {
                return self.updateCart();
              });
            });
          } else {
            return this.request('/cart/change.js', {
              quantity: q,
              id: id
            }, function() {
              return self.updateCart();
            });
          }
        },
        closeCookiePopup: function() {
          this.cookiePopup = false;
          return localStorage.setItem('mbcookie', 'shown');
        },
        closeCountryPopup: function() {
          this.countryPopup = false;
          return localStorage.setItem('mbcountry', 'shown');
        },
        searchProducts: function(text) {
          self = this;
          if (text) {
            return this.request('/search/suggest.json?q=' + text + '&resources[type]=product&resources[options][unavailable_products]=show&resources[options][fields]=title,product_type,variants.title,vendor,tag', null, function(res) {
              var currentLocation, i, productSuggestions;
              productSuggestions = res.resources.results.products;
              if (productSuggestions && productSuggestions.length > 0) {
                currentLocation = window.location.href;
                if (productSuggestions.length > 0) {
                  i = 0;
                  while (i < productSuggestions.length) {
                    if (productSuggestions[i].title.includes('++')) {
                      if (currentLocation.includes('/fr')) {
                        productSuggestions[i].title = productSuggestions[i].title.split('++')[1];
                      } else {
                        productSuggestions[i].title = productSuggestions[i].title.split('++')[0];
                      }
                    }
                    if (currentLocation.includes('/fr')) {
                      productSuggestions[i].url = '/fr' + productSuggestions[i].url;
                    }
                    i++;
                  }
                }
                return self.productSuggestions = productSuggestions;
              } else {
                return self.productSuggestions = [];
              }
            }, 'GET');
          } else {
            return self.productSuggestions = [];
          }
        },
        menuOpen: function() {
          if (window.outerWidth < 1360) {
            return this.menuPopup = !this.menuPopup;
          } else {
            return true;
          }
        },
        openSub: function(e) {
          if (window.outerWidth < 1360) {
            if (e.target.parentElement.nodeName === 'LI') {
              return e.target.nextElementSibling.nextElementSibling.classList.add('active');
            } else {
              return e.target.parentElement.parentElement.classList.remove('active');
            }
          }
        },
        changeLang: function(code) {
          document.querySelector('[name="language_code"]').value = code;
          return document.querySelector('header #localization_form').submit();
        },
        updateSubAddress: function() {
          var data;
          self = this;
          this.addressPopup.loading = true;
          data = {
            module: 'checkout1',
            action: 'subscriptions/address',
            address: this.addressPopup
          };
          return this.request('/apps/mm-master', data, function(res) {
            self.addressPopup = null;
            return self.$children.forEach(function(child) {
              if (child.$vnode.tag.indexOf('-account') > -1) {
                return child.$children.forEach(function(subchild) {
                  if (subchild.$vnode.tag.indexOf('-subs') > -1) {
                    return subchild.load();
                  }
                });
              }
            });
          });
        },
        updateNextDelivery: function() {
          var data;
          self = this;
          this.skipPopup.loading = true;
          data = {
            module: 'checkout1',
            action: 'subscriptions/skip',
            skip: this.skipPopup
          };
          return this.request('/apps/mm-master', data, function(res) {
            self.skipPopup = null;
            return self.$children.forEach(function(child) {
              if (child.$vnode.tag.indexOf('-account') > -1) {
                return child.$children.forEach(function(subchild) {
                  if (subchild.$vnode.tag.indexOf('-subs') > -1) {
                    return subchild.load();
                  }
                });
              }
            });
          });
        },
        subscribe: function() {},
        subscribeFooter: function() {}
      },
      components: {
        'product': require('./store/_product'),
        'login': require('./store/_login'),
        'sort': require('./store/_sort'),
        'adres': require('./store/_adres'),
        'checkout': require('./store/_checkout'),
        'pay': require('./store/_pay'),
        'collection': require('./store/_collection'),
        'account': require('./store/_account'),
        'reviews': require('./store/_reviews'),
        'reviews-multi': require('./store/_reviews_multi'),
        'slider-products': require('./sliders/_products'),
        'slider-seen': require('./sliders/_seen'),
        'slider-main': require('./sliders/_main'),
        'slider-reviews': require('./sliders/_reviews'),
        'marquee': require('./sliders/_marquee'),
        'events': require('./other/_events'),
        'forms': require('./other/_forms'),
        'faq': require('./other/_faq'),
        'tabs': require('./other/_tabs')
      }
    });
  },
  scroller: function(e) {},
  resizer: function(e) {
    var header;
    header = document.querySelector('header');
    if (document.querySelector('main') !== null) {
      return document.querySelector('main').style.paddingTop = header.getBoundingClientRect().height + 'px';
    }
  }
};


},{"./other/_events":3,"./other/_faq":4,"./other/_forms":5,"./other/_tabs":6,"./sliders/_main":7,"./sliders/_marquee":8,"./sliders/_products":9,"./sliders/_reviews":10,"./sliders/_seen":11,"./store/_account":12,"./store/_adres":13,"./store/_checkout":15,"./store/_collection":16,"./store/_login":17,"./store/_pay":18,"./store/_product":19,"./store/_reviews":20,"./store/_reviews_multi":21,"./store/_sort":23}],2:[function(require,module,exports){
app = require('./_app')

window.addEventListener('scroll', app.scroller.bind(app))
window.addEventListener('resize', app.resizer.bind(app))


app.init()
},{"./_app":1}],3:[function(require,module,exports){
module.exports = {
  props: ['max', 'type'],
  data: function() {
    return {
      events: [],
      loading: true,
      show: 'all'
    };
  },
  mounted: function() {
    var data, self;
    self = this;
    data = {
      module: 'beljanski',
      action: 'events',
      limit: this.max ? this.max : 9999,
      type: this.type ? this.type : 'Online'
    };
    return this.$root.request('/apps/mm-master', data, function(res) {
      self.loading = false;
      Vue.set(self, 'events', res.events);
      setTimeout(function() {
        var url;
        if (location.href.indexOf('#') > -1 && self.type !== 'On Demand') {
          url = location.href.split('#');
          return self.$root.scroller.setPosition(0, document.querySelector('[data-on-demand]').getBoundingClientRect().top + self.$root.scroller.offset.y);
        }
      }, 0);
      return setTimeout(function() {
        return window.MHO.sameHeights();
      }, 100);
    });
  }
};


},{}],4:[function(require,module,exports){
module.exports = {
  methods: {
    slideDown: function(element) {
      var height;
      element.parentElement.classList.add('active');
      element.style.height = 'auto';
      height = element.clientHeight + 'px';
      element.style.height = '0px';
      return setTimeout((function() {
        element.style.height = height;
      }), 0);
    },
    slideUp: function(element) {
      element.style.height = '0px';
      return element.parentElement.classList.remove('active');
    }
  },
  mounted: function() {
    var qas, questions, self;
    self = this;
    qas = this.$el.querySelectorAll('.row');
    questions = this.$el.querySelectorAll('.question');
    questions.forEach;
    return questions.forEach(function(question) {
      return question.addEventListener('click', function(e) {
        e.preventDefault();
        return qas.forEach(function(qa) {
          var answer;
          answer = qa.querySelector('.answer');
          if (qa.dataset.id === e.target.parentElement.dataset.id) {
            if (qa.classList.contains('active')) {
              return self.slideUp(answer);
            } else {
              return self.slideDown(answer);
            }
          } else {
            return self.slideUp(answer);
          }
        });
      });
    });
  }
};


},{}],5:[function(require,module,exports){
module.exports = {
  data: function() {
    return {
      status: null,
      email: '',
      country: '',
      province: '',
      tags: ''
    };
  },
  watch: {
    country: function(val) {
      var self;
      self = this;
      return this.$nextTick(function() {
        var option, provinces, provinces_html;
        option = self.$refs.shipping_country.querySelector('[value="' + val + '"]');
        if (!option || option.dataset.provinces === '[]') {
          return self.province = '';
        } else {
          provinces = JSON.parse('[' + option.dataset.provinces + ']');
          provinces_html = '';
          provinces = provinces.filter(function(p) {
            return blacklist.indexOf(p[1]) === -1;
          });
          provinces.forEach(function(p) {
            return provinces_html += '<option value="' + p[1] + '">' + p[1] + '</option>';
          });
          self.$refs.shipping_province.innerHTML = provinces_html;
          return self.province = provinces[0][1];
        }
      });
    }
  },
  methods: {
    submit: function(e) {
      var self;
      e.preventDefault();
      self = this;
      if (this.$refs.honeypot.value === '') {
        return this.$validator.validate().then(function(res) {
          var data;
          if (res) {
            self.status = 'sending';
            data = {
              form: self.$root.formalize(e.target)
            };
            return self.$root.request('https://mb.minionmade.net/forms?shop=staging1-mb.myshopify.com', data, function(res) {
              self.status = 'sent';
              if (self.$root.freebiePopup !== '') {
                setTimeout(function() {
                  self.status = null;
                  return self.$root.freebiePopup = '';
                }, 10000);
                return window.open(self.$root.freebiePopup.split('|')[1]);
              }
            });
          }
        });
      }
    }
  }
};


},{}],6:[function(require,module,exports){
module.exports = {
  data: function() {
    return {
      tab: 1
    };
  }
};


},{}],7:[function(require,module,exports){
module.exports = {
  data: function() {
    return {
      slider: null
    };
  },
  mounted: function() {
    return this.slider = tns({
      container: this.$el,
      mode: 'gallery',
      controls: true,
      nav: true,
      speed: 500,
      autoHeight: true,
      animateIn: 'fadeIn',
      animateOut: 'fadeOut',
      navPosition: 'bottom'
    });
  }
};


},{}],8:[function(require,module,exports){
module.exports = {
  mounted: function() {
    var clone, firstElement, i, parentSelector;
    parentSelector = this.$refs.text;
    clone = parentSelector.innerHTML;
    firstElement = parentSelector.children[0];
    i = 0;
    parentSelector.insertAdjacentHTML('beforeend', clone);
    parentSelector.insertAdjacentHTML('beforeend', clone);
    return setInterval(function() {
      firstElement.style.marginLeft = '-' + i + 'px';
      if (i > firstElement.clientWidth) {
        i = 0;
      }
      return i = i + 0.2;
    }, 0);
  }
};


},{}],9:[function(require,module,exports){
module.exports = {
  props: ['slides', 'related'],
  methods: {
    slider: function() {
      return tns({
        container: this.$el,
        items: 2,
        gutter: 10,
        nav: true,
        navPosition: 'bottom',
        controls: true,
        loop: true,
        responsive: {
          768: {
            gutter: 15,
            items: 3
          },
          1024: {
            gutter: 30,
            items: this.slides ? this.slides : 4
          }
        }
      });
    }
  },
  mounted: function() {
    var self;
    self = this;
    if (this.related === '') {
      return this.slider();
    } else {
      return this.$root.request('/collections/all/' + this.related + '?view=related', [], function(res) {
        self.$el.innerHTML = res;
        return self.slider();
      }, 'GET', false);
    }
  }
};


},{}],10:[function(require,module,exports){
module.exports = {
  data: function() {
    return {
      slider: null
    };
  },
  mounted: function() {
    return this.slider = tns({
      container: this.$el,
      controls: false,
      nav: true,
      speed: 500,
      autoHeight: true,
      navPosition: 'bottom',
      center: true,
      edgePadding: 50,
      gutter: 5,
      autoplay: true,
      autoplayButtonOutput: false,
      responsive: {
        768: {
          edgePadding: 100,
          gutter: 30
        },
        1024: {
          edgePadding: 200,
          gutter: 30
        },
        1200: {
          edgePadding: 300,
          gutter: 30
        },
        1360: {
          edgePadding: 400,
          gutter: 40
        },
        1600: {
          edgePadding: 500,
          gutter: 40
        },
        1800: {
          edgePadding: 600,
          gutter: 50
        }
      }
    });
  }
};


},{}],11:[function(require,module,exports){
module.exports = {
  data: function() {
    return {
      slider: null
    };
  },
  mounted: function() {
    return this.slider = tns({
      container: this.$el,
      mode: 'gallery',
      controls: false,
      nav: false,
      speed: 500,
      autoHeight: true,
      animateIn: 'fadeIn',
      animateOut: 'fadeOut'
    });
  },
  methods: {
    go: function(index) {
      return this.slider.goTo(index);
    }
  }
};


},{}],12:[function(require,module,exports){
module.exports = {
  props: ['addresses', 'orders'],
  data: function() {
    return {
      view: 'home',
      addressPage: 1,
      orderPage: 1
    };
  },
  methods: {
    showOrder: function(e) {
      return e.target.closest('.order-item').classList.add('full');
    },
    hideOrder: function(e) {
      return e.target.closest('.order-item').classList.remove('full');
    },
    reorder: function(e, items, addressId) {
      var self;
      self = this;
      e.target.closest('.order-item').classList.add('disabled');
      return this.$root.request('/cart/clear.js', null, function() {
        var data, line_items_id;
        line_items_id = items.split(',');
        data = [];
        line_items_id.forEach(function(el) {
          var params;
          params = el.split(':');
          return data.push({
            id: params[0],
            quantity: params[1]
          });
        });
        return self.$root.request('/cart/add.js', {
          items: data
        }, function() {
          var prefix;
          prefix = lang === 'en' ? '/' : '/' + lang + '/';
          return window.location.href = prefix + 'pages/checkout?reorder=' + addressId;
        });
      });
    }
  },
  mounted: function() {},
  components: {
    'rewards': require('./_rewards'),
    'affiliate': require('./_affiliate'),
    'subs': require('./_subs')
  }
};


},{"./_affiliate":14,"./_rewards":22,"./_subs":24}],13:[function(require,module,exports){
module.exports = {
  methods: {}
};


},{}],14:[function(require,module,exports){
module.exports = {
  props: ['id'],
  data: function() {
    return {
      page: 1,
      all: [],
      profile: {},
      loading: false,
      saving: false,
      requesting: false,
      next: null,
      banners: {
        page: 1,
        lang: '',
        topic: '',
        size: '',
        data: []
      }
    };
  },
  computed: {
    list: function() {
      return this.all.slice(0, 5);
    },
    banners_list: function() {
      var list, self;
      self = this;
      list = [];
      this.banners.page = 1;
      this.banners.data.forEach(function(topic) {
        if (self.banners.topic === '' || topic.topic === self.banners.topic) {
          return topic.banners.forEach(function(banner) {
            if (self.banners.size === '' || banner.size === self.banners.size) {
              if (banner.image_en && (self.banners.lang === '' || self.banners.lang === 'en')) {
                list.push(banner.image_en);
              }
              if (banner.image_fr && (self.banners.lang === '' || self.banners.lang === 'fr')) {
                return list.push(banner.image_fr);
              }
            }
          });
        }
      });
      return list;
    },
    banners_topics: function() {
      var list;
      list = [];
      this.banners.data.forEach(function(topic) {
        return list.push(topic.topic);
      });
      return list;
    },
    banners_sizes: function() {
      var list;
      list = [];
      this.banners.data.forEach(function(topic) {
        return topic.banners.forEach(function(banner) {
          return list.push(banner.size);
        });
      });
      list = list.filter(function(x, i, a) {
        return a.indexOf(x) === i;
      }).sort();
      return list;
    }
  },
  methods: {
    money: function(val, currency) {
      var quota, symbol;
      quota = Shopify.formatMoney(val).replace('$', '').replace('€', '');
      symbol = currency === 'EUR' ? '€' : '$';
      return symbol + quota;
    },
    load: function() {
      var data, self;
      self = this;
      this.loading = true;
      data = {
        module: 'affiliate',
        action: 'profile',
        id: this.id
      };
      return this.$root.request('/apps/mm-master', data, function(res) {
        if (res.error) {
          return alert(res.error.message);
        } else {
          Vue.set(self, 'profile', res.profile);
          Vue.set(self, 'next', (new Date(res.next)).toLocaleString((lang === 'fr' ? 'fr-FR' : 'en-US'), {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
          }));
          return self.loading = false;
        }
      });
    },
    prepare: function() {
      var schemas;
      schemas = [];
      document.querySelectorAll('.affiliate-schema').forEach(function(schema) {
        return schemas.push(JSON.parse(schema.innerText));
      });
      return Vue.set(this.banners, 'data', schemas);
    },
    prev: function() {
      return this.page--;
    },
    next: function() {
      return this.page++;
    },
    save: function() {
      var data, self;
      self = this;
      this.saving = true;
      data = {
        module: 'affiliate',
        action: 'profile/save',
        id: this.id,
        email: this.profile.program.email
      };
      return this.$root.request('/apps/mm-master', data, function(res) {
        return self.saving = false;
      });
    },
    request: function(currency) {
      var data, format, self;
      self = this;
      this.requesting = currency;
      format = lang === 'fr' ? 'fr-FR' : 'en-US';
      data = {
        module: 'affiliate',
        action: 'profile/request',
        id: this.id,
        c: currency,
        date: (new Date()).toLocaleString(format, {
          month: 'short',
          day: 'numeric',
          year: 'numeric'
        })
      };
      return this.$root.request('/apps/mm-master', data, function(res) {
        self.profile.total[currency].requested = true;
        return self.requesting = false;
      });
    }
  },
  mounted: function() {
    this.load();
    return this.prepare();
  }
};


},{}],15:[function(require,module,exports){
module.exports = {
  data: function() {
    return {
      loading: true,
      checked: false,
      error: '',
      error_payment: false,
      ordering: false,
      checkoutId: null,
      tokenized: false,
      cart: cart,
      customer: customer,
      addresses: addresses,
      currency: currency,
      phone: '',
      added_samples: [],
      shipping: {
        rate: '',
        rates: [],
        timeout: null,
        error: 'Loading...'
      },
      tax: {
        total: 0,
        rate: 0,
        shipping: 0,
        loading: false
      },
      discount: {
        code: '',
        rate: 0,
        applied: '',
        loading: false,
        error: '',
        lines: []
      },
      gifts: [],
      gifts_ids: {},
      gift: {
        error: '',
        code: '',
        loading: false,
        last_code: ''
      },
      note: '',
      points_used: 0,
      global_discount: global_discount,
      only_gift: false,
      only_virtual: false,
      pickup_other_states: false,
      dropinstance: null,
      is_free_shipping: false,
      apply_free_shipping: cart.is_eligible && this.$root.market === 'US',
      free_shipping_code: '',
      only_one_time: true,
      affiliate: Cookies.get('mbaffiliate'),
      defaultCountryCode: 'US',
      reorder: false,
      points_promo: null,
      rewards_slider: null
    };
  },
  computed: {
    shipping_price: function() {
      var res, self;
      self = this;
      res = 0;
      if (this.discount.applied !== '' && this.discount.applied.substr(-1) === '+') {
        return 0;
      } else {
        this.shipping.rates.forEach(function(rate) {
          if (rate.handle === self.shipping.rate) {
            res = rate;
          }
        });
        if (res) {
          return res.priceV2.amount * 100;
        } else {
          return 0;
        }
      }
    },
    shipping_items_count: function() {
      var items;
      items = 0;
      this.cart.items.forEach(function(item) {
        if (item.requires_shipping) {
          return items += item.quantity;
        }
      });
      return items;
    },
    gifts_total: function() {
      var total;
      total = 0;
      this.gifts.forEach(function(gift) {
        return total += gift.amount;
      });
      return total;
    },
    order_sub_total: function() {
      var total;
      total = this.cart.total_price + this.shipping_price + this.tax.total - this.discount.rate - this.gifts_total;
      if (this.discount.applied === 'BUY2GET3') {
        total += this.discount.rate;
      }
      if (this.is_free_shipping && this.tax.total > 0 && this.global_discount) {
        total += this.tax.shipping;
      }
      if (this.is_free_shipping && this.shipping_price > 0 && this.global_discount) {
        total -= this.shipping_price;
      }
      return total;
    },
    order_total: function() {
      var total;
      total = this.discount.applied !== '' ? this.cart.items_subtotal_price : this.cart.total_price;
      total += this.shipping_price;
      total += this.tax.total;
      total -= this.discount.rate;
      total -= this.gifts_total;
      total -= this.points_used;
      if (this.global_discount && this.discount.applied === '') {
        total = total + this.discount.rate;
      }
      if (this.discount.applied === 'BUY2GET3') {
        total += this.discount.rate;
      }
      if (this.is_free_shipping && this.tax.total > 0 && this.global_discount) {
        total += this.tax.shipping;
      }
      if (this.is_free_shipping && this.shipping_price > 0 && this.global_discount) {
        total -= this.shipping_price;
      }
      if (this.dropinstance) {
        this.dropinstance.updateConfiguration('paypal', 'amount', total / 100);
      }
      return total;
    },
    inventoryCheck: function() {
      var c, valid;
      valid = true;
      c = this.customer.shipping_address.country;
      if (c) {
        this.cart.items.forEach(function(item) {
          if (c === 'United States' || c === 'United Kingdom') {
            if (item.levels) {
              if (item.levels['96574439600'] < item.quantity) {
                valid = false;
              }
            }
          } else {
            if (item.levels) {
              if (item.levels['99829678256'] < item.quantity) {
                valid = false;
              }
            }
          }
          if (item.strict) {
            if (item.strict.length) {
              if (item.strict.indexOf(c) === -1) {
                return valid = false;
              }
            }
          }
        });
      }
      return valid;
    }
  },
  watch: {
    'customer.shipping_address.country': function(val) {
      var self;
      self = this;
      if (val !== 'United States') {
        self.apply_free_shipping = false;
      }
      this.updateDefaultCountryCode(val);
      return this.$nextTick(function() {
        var option, provinces, provinces_html;
        option = self.$refs.shipping_country.querySelector('[value="' + val + '"]');
        if (val !== 'United States' && val !== 'Canada' && val !== 'Spain' && val !== 'Malaysia') {
          self.customer.shipping_address.province = '';
          self.customer._province = false;
        } else {
          provinces = JSON.parse('[' + option.dataset.provinces + ']');
          provinces_html = '';
          provinces = provinces.filter(function(p) {
            return blacklist.indexOf(p[1]) === -1;
          });
          provinces.forEach(function(p) {
            return provinces_html += '<option value="' + p[0] + '">' + p[0] + '</option>';
          });
          self.$refs.shipping_province.innerHTML = provinces_html;
          self.customer.shipping_address.province = provinces[0][0];
          self.customer._province = true;
        }
        return setTimeout((function() {
          self.address();
        }), 100);
      });
    },
    'customer.billing_address.country': function(val) {
      var self;
      self = this;
      if (this.only_virtual) {
        this.updateDefaultCountryCode(val);
      }
      return this.$nextTick(function() {
        var option, provinces, provinces_html;
        option = self.$refs.billing_country.querySelector('[value="' + val + '"]');
        if (val !== 'United States' && val !== 'Canada' && val !== 'Spain') {
          self.customer.billing_address.province = '';
          return self.customer._province2 = false;
        } else {
          provinces = JSON.parse('[' + option.dataset.provinces + ']');
          provinces_html = '';
          provinces = provinces.filter(function(p) {
            return blacklist.indexOf(p[1]) === -1;
          });
          provinces.forEach(function(p) {
            return provinces_html += '<option value="' + p[0] + '">' + p[0] + '</option>';
          });
          self.$refs.billing_province.innerHTML = provinces_html;
          self.customer.billing_address.province = provinces[0][0];
          return self.customer._province2 = true;
        }
      });
    },
    'customer.billing_same': function(val) {
      if (!val) {
        Vue.set(this.customer, 'billing_address', {
          first_name: '',
          last_name: '',
          address1: '',
          address2: '',
          city: '',
          country: '',
          province: '',
          zip: ''
        });
        return this.customer._province2 = false;
      }
    },
    'customer._saved': function(val) {
      var self;
      self = this;
      if (val === '') {
        Vue.set(this.customer, 'shipping_address', {
          first_name: '',
          last_name: '',
          address1: '',
          address2: '',
          city: '',
          country: '',
          province: '',
          zip: '',
          phone: ''
        });
        this.phone = '';
        return setTimeout(function() {
          return self.errors.clear();
        }, 10);
      } else {
        return this.addresses.forEach(function(a) {
          var province;
          if (parseInt(val) === a.id) {
            province = JSON.parse(JSON.stringify(a.province));
            Vue.set(self.customer, 'shipping_address', JSON.parse(JSON.stringify(a)));
            self.phone = a.phone;
            setTimeout((function() {
              Vue.set(self.customer.shipping_address, 'province', province);
            }), 100);
          }
        });
      }
    },
    'customer._saved2': function(val) {
      var self;
      self = this;
      if (val === '') {
        Vue.set(this.customer, 'billing_address', {
          first_name: '',
          last_name: '',
          address1: '',
          address2: '',
          city: '',
          country: '',
          province: '',
          zip: ''
        });
        if (this.only_virtual) {
          Vue.set(this.customer.billing_address, 'phone', '');
          this.phone = '';
        }
        return setTimeout(function() {
          return self.errors.clear();
        }, 10);
      } else {
        return this.addresses.forEach(function(a) {
          var province2;
          if (parseInt(val) === a.id) {
            province2 = JSON.parse(JSON.stringify(a.province));
            Vue.set(self.customer, 'billing_address', JSON.parse(JSON.stringify(a)));
            if (self.only_virtual) {
              self.phone = a.phone;
            }
            setTimeout((function() {
              Vue.set(self.customer.billing_address, 'province', province2);
            }), 100);
          }
        });
      }
    },
    'customer.shipping_address': {
      deep: true,
      handler: function() {
        var self;
        self = this;
        if (this.shipping.timeout) {
          clearTimeout(this.shipping.timeout);
        }
        return this.shipping.timeout = setTimeout((function() {
          self.address();
        }), 1000);
      }
    },
    'discount.code': function(val) {
      if (val === '') {
        return this.discount.error = '';
      }
    },
    'note': function(val) {
      if (val.length > 35) {
        return this.note = val.substring(0, 35);
      }
    },
    shipping_price: function() {
      var address, self;
      self = this;
      if (this.shipping.rate === 'in-store-pickup') {
        if (this.customer.shipping_address.province !== 'New York') {
          if (this.pickup_other_states === true) {
            return self.ship_update(self.shipping.rate);
          } else {
            this.pickup_other_states = true;
            this.shipping.error = 'Loading...';
            address = JSON.parse(JSON.stringify(this.customer.shipping_address));
            address.province = 'New York';
            address.province_code = 'NY';
            delete address.id;
            address.zip = 10022;
            return this.$root.request('/apps/mm-master', {
              module: 'checkout1',
              action: 'address',
              checkoutId: self.checkoutId,
              shipping_address: address,
              items: this.shipping_items_count
            }, function(res) {
              self.shipping.error = false;
              return self.ship_update(self.shipping.rate);
            });
          }
        } else {
          if (this.pickup_other_states === true) {
            this.pickup_other_states = false;
            this.shipping.error = 'Loading...';
            return this.$root.request('/apps/mm-master', {
              module: 'checkout1',
              action: 'address',
              checkoutId: self.checkoutId,
              shipping_address: this.customer.shipping_address,
              items: this.shipping_items_count
            }, function(res) {
              self.shipping.error = false;
              return self.ship_update(self.shipping.rate);
            });
          } else {
            return self.ship_update(self.shipping.rate);
          }
        }
      } else {
        if (this.pickup_other_states === true) {
          this.pickup_other_states = false;
          this.shipping.error = 'Loading...';
          return this.$root.request('/apps/mm-master', {
            module: 'checkout1',
            action: 'address',
            checkoutId: self.checkoutId,
            shipping_address: this.customer.shipping_address,
            items: this.shipping_items_count
          }, function(res) {
            self.shipping.error = false;
            return self.ship_update(self.shipping.rate);
          });
        } else {
          return self.ship_update(self.shipping.rate);
        }
      }
    },
    is_free_shipping: function(val) {
      if (val && this.tax.total > 0 && this.global_discount) {
        return this.tax.shipping = -this.shipping_price * 0.0887;
      } else {
        return this.tax.shipping = 0;
      }
    }
  },
  methods: {
    money: function(price) {
      return Shopify.formatMoney(price);
    },
    updatePhone: function(payload) {
      if (payload.phoneNumber) {
        if (this.only_virtual) {
          if (payload.isValid) {
            return this.customer.billing_address.phone = payload.formattedNumber;
          } else {
            return this.customer.billing_address.phone = '';
          }
        } else {
          if (payload.isValid) {
            return this.customer.shipping_address.phone = payload.formattedNumber;
          } else {
            return this.customer.shipping_address.phone = '';
          }
        }
      }
    },
    updateDefaultCountryCode: function(country) {
      var countries;
      countries = {
        'United States': 'US',
        'Australia': 'AU',
        'Austria': 'AT',
        'Belgium': 'BE',
        'Bosnia And Herzegovina': 'BA',
        'Bulgaria': 'BU',
        'Canada': 'CA',
        'Cyprus': 'CY',
        'Czech Republic': 'CZ',
        'Denmark': 'DK',
        'Estonia': 'EE',
        'Finland': 'FI',
        'France': 'FR',
        'French Polynesia': 'PF',
        'Germany': 'DE',
        'Greece': 'GR',
        'Guadeloupe': 'GP',
        'Hong Kong': 'HK',
        'Hungary': 'HU',
        'Iceland': 'IS',
        'India': 'IN',
        'Ireland': 'IE',
        'Italy': 'IT',
        'Japan': 'JP',
        'Latvia': 'LV',
        'Lithuania': 'LT',
        'Luxembourg': 'LU',
        'Malaysia': 'MY',
        'Malta': 'MT',
        'Martinique': 'MQ',
        'Mauritius': 'MU',
        'Monaco': 'MC',
        'Netherlands': 'NL',
        'New Zealand': 'NZ',
        'Norway': 'NO',
        'Philippines': 'PH',
        'Poland': 'PL',
        'Portugal': 'PT',
        'Reunion': 'RE',
        'Romania': 'RO',
        'San Marino': 'SM',
        'Serbia': 'RS',
        'Singapore': 'SG',
        'Slovakia': 'SK',
        'Slovenia': 'SI',
        'South Africa': 'ZA',
        'South Korea': 'KR',
        'Spain': 'ES',
        'Sweden': 'SW',
        'Switzerland': 'CH',
        'Taiwan': 'TW',
        'United Kingdom': 'GB',
        'Holy See (Vatican City State)': 'VA'
      };
      return this.defaultCountryCode = countries[country];
    },
    order: function(nonce, type) {
      var self;
      self = this;
      return this.$validator.validate().then(function(res) {
        var shipping;
        shipping === false;
        if (self.shipping.rate !== '') {
          shipping = true;
        } else {
          shipping = true;
          self.cart.items.forEach(function(item) {
            if (item.requires_shipping) {
              return shipping = false;
            }
          });
        }
        if (res && shipping) {
          self.error = '';
          self.error_payment = false;
          self.ordering = true;
          self.$root.request('/apps/mm-master', {
            module: 'checkout1',
            action: 'pay',
            nonce: nonce,
            type: type,
            checkoutId: self.checkoutId,
            live: customer._live,
            d: JSON.stringify({
              affiliate: self.affiliate,
              customer: self.customer,
              shipping: self.shipping,
              tax: self.tax,
              cart: self.cart,
              currency: self.currency,
              discount: self.discount,
              note: self.note,
              order_method: 'Method::Internet',
              points_used: self.points_used,
              gifts: self.gifts,
              gifts_ids: self.gifts_ids,
              global_discount: self.global_discount,
              apply_free_shipping: self.apply_free_shipping,
              is_free_shipping: self.is_free_shipping,
              free_shipping_code: self.free_shipping_code,
              only_virtual: self.only_virtual,
              points_promo: self.points_promo
            })
          }, function(res) {
            var error;
            if (res.error) {
              if (res.error === 403) {
                error = lang === 'fr' ? 'Payment refusé' : 'Card was declined';
                if (res.message) {
                  error += ': ' + res.message;
                }
                self.error = error;
                self.error_payment = true;
              } else {
                self.error = window.errors_t[res.message.trim()] ? window.errors_t[res.message.trim()] : res.message;
              }
              self.ordering = false;
            } else {
              localStorage.removeItem('checkoutId');
              self.$root.request('/cart/clear.js', null, function(r) {
                var prefix;
                prefix = lang === 'en' ? '/' : '/' + lang + '/';
                if (window.customer.id) {
                  self.$root.request('/cart?view=logged', null, function(r) {
                    if (r.success) {
                      return window.location.href = prefix + 'account/orders/' + res.token + '?view=confirmation';
                    } else {
                      return window.location.href = prefix + 'pages/order-confirmed';
                    }
                  }, 'GET');
                } else {
                  window.location.href = prefix + 'pages/order-confirmed';
                }
              });
            }
          });
        } else {
          self.error = lang === 'en' ? 'Required fields are empty or are invalid' : 'Les champs obligatoires sont vides ou invalides';
        }
      });
    },
    address: function() {
      var self;
      self = this;
      self.shipping.error = 'Loading...';
      return self.$root.request('/apps/mm-master', {
        module: 'checkout1',
        action: 'address',
        checkoutId: self.checkoutId,
        shipping_address: this.customer.shipping_address,
        items: this.shipping_items_count
      }, function(res) {
        var found, new_shipping_rates;
        if (res.shipping_rates && res.shipping_rates[0] && res.shipping_rates[0].handle.indexOf('pickup') > -1 && !self.only_one_time) {
          res.shipping_rates.splice(0, 1);
        }
        if (res.error) {
          Vue.set(self.shipping, 'rates', []);
          self.shipping.rate = '';
          self.shipping.error = res.message;
        } else {
          if (res.shipping_rates[0]) {
            new_shipping_rates = [];
            if (self.apply_free_shipping) {
              res.shipping_rates.forEach(function(r) {
                var temp;
                temp = r;
                if (r.handle.includes('fedex-ground') || r.handle.includes('us-smart-post')) {
                  temp.priceV2.amount = "0.0";
                  temp.title += " - FREE";
                }
                return new_shipping_rates.push(temp);
              });
            } else {
              new_shipping_rates = res.shipping_rates;
            }
            Vue.set(self.shipping, 'rates', new_shipping_rates);
            found = false;
            new_shipping_rates.forEach(function(r) {
              if (r.handle === self.shipping.rate) {
                found = true;
              }
            });
            if (!found) {
              if (self.customer.shipping_address.country === 'United States') {
                if (self.customer.shipping_address.province === 'New York' || !new_shipping_rates[1] || new_shipping_rates[0].handle.indexOf('pickup') === -1) {
                  self.shipping.rate = new_shipping_rates[0].handle;
                } else {
                  self.shipping.rate = new_shipping_rates[1].handle;
                }
              } else {
                self.shipping.rate = new_shipping_rates[0].handle;
              }
              self.ship_update(self.shipping.rate);
            }
            self.shipping.error = false;
          } else {
            Vue.set(self.shipping, 'rates', []);
            self.shipping.rate = '';
            self.ship_update('');
            self.shipping.error = 'Unfortunately, we are not able to ship to provided address';
            Vue.set(self.shipping, 'rates', []);
          }
          self.get_tax();
        }
      });
    },
    ship_update: function(handle) {
      var self;
      self = this;
      return this.$root.request('/apps/mm-master', {
        module: 'checkout1',
        action: 'ship/update',
        checkoutId: self.checkoutId,
        rateHandle: handle
      }, function(res) {
        return self.get_tax();
      });
    },
    clear_discount: function() {
      Vue.set(this, 'discount', {
        code: '',
        rate: 0,
        applied: '',
        loading: false,
        error: '',
        lines: []
      });
    },
    update_b2g3: function(img_src, v_id, v_price, v_title) {
      this.discount.item.variant_id = v_id;
      this.discount.item.variant_title = v_title;
      this.discount.item.image = img_src;
      this.discount.item.price = v_price;
      this.discount.rate = v_price * this.discount.item.quantity;
    },
    apply_points_discount: function() {
      var self;
      self = this;
      if (self.order_sub_total > self.customer._points) {
        self.points_used = self.customer._points;
      } else {
        self.points_used = self.order_sub_total;
      }
      if (window.noUiSlider !== null) {
        self.rewards_slider.noUiSlider.updateOptions({
          range: {
            min: 0,
            max: self.points_used
          }
        });
        self.rewards_slider.noUiSlider.set(self.points_used);
      }
    },
    adjust_points_discount: function() {
      var self;
      self = this;
      self.points_used = parseInt(self.rewards_slider.noUiSlider.get());
    },
    apply_discount: function(code, reset, global, is_free) {
      var discount_item, discount_min_value, discount_rate, is_valid, self;
      if (code == null) {
        code = null;
      }
      if (reset == null) {
        reset = false;
      }
      if (global == null) {
        global = false;
      }
      if (is_free == null) {
        is_free = true;
      }
      self = this;
      if (!reset) {
        self.discount.loading = true;
      }
      if (code) {
        if (typeof code !== 'string') {
          code = self.discount.code;
        }
      } else {
        code = self.discount.code;
      }
      is_valid = false;
      if (code.toLowerCase() === 'love24') {
        if (self.cart.is_realbuild_pro) {
          return;
        }
        self.cart.items.forEach(function(item) {
          if (item.title.includes('ReaLBuild')) {
            return is_valid = true;
          }
        });
        if (!is_valid) {
          self.discount.loading = false;
          self.discount.error = 'Discount Code is not valid';
          return;
        }
      }
      if (code.toLowerCase() === 'buy2get3') {
        discount_rate = 0;
        discount_item = {};
        discount_min_value = 9999999999;
        self.cart.items.forEach(function(item) {
          if (item.product_id === 6677023097008) {
            discount_rate += item.quantity;
            if (discount_min_value > parseInt(item.final_price)) {
              return discount_min_value = parseInt(item.final_price);
            }
          }
        });
        if (discount_rate >= 2) {
          discount_item = {
            image: '',
            quantity: parseInt(discount_rate / 2),
            product_title: 'OnkoTea®',
            variant_title: '',
            variant_id: 0,
            price: 0,
            min_price: discount_min_value
          };
          discount_rate = discount_min_value * discount_item.quantity;
          Vue.set(self, 'discount', {
            code: '',
            rate: discount_rate,
            applied: 'BUY2GET3',
            loading: false,
            error: '',
            lines: [],
            picked_item: false,
            item: discount_item
          });
        }
        self.discount.loading = false;
        return;
      }
      return self.$root.request('/apps/mm-master', {
        module: 'checkout1',
        action: 'discount',
        checkoutId: self.checkoutId,
        discount: code,
        current_discount: self.discount.rate,
        global_discount: self.global_discount,
        country: self.customer.shipping_address.country,
        shipping: self.shipping_price
      }, function(res) {
        var lines;
        if (res.points) {
          self.discount.loading = false;
          if (self.global_discount === '' || (self.global_discount.indexOf('Healthcare Professional') === -1 && self.global_discount.indexOf('IPIC') === -1 && self.global_discount.indexOf('VIP') === -1)) {
            self.points_promo = {
              value: res.points,
              code: self.discount.code
            };
            self.discount.code = '';
          } else {
            self.discount.error = lang === 'fr' ? 'Le code de réduction n\'est pas valide' : 'Discount Code is not valid';
          }
        } else {
          if (!res.reapply_global) {
            self.discount.loading = false;
          }
          if (res.error) {
            if (!global) {
              if (res.message === 'DISCOUNT_LOWER') {
                self.discount.error = lang === 'fr' ? 'Vous avez une remise plus élevée appliquée actuellement' : 'You have higher discount applied currently';
              } else {
                self.discount.error = lang === 'fr' ? 'Le code de réduction n\'est pas valide' : 'Discount Code is not valid';
              }
              if (self.global_discount) {
                self.discount.loading = false;
                self.apply_discount(self.global_discount, true, true);
              }
            }
          } else {
            if (is_free) {
              self.is_free_shipping = res.is_free_shipping;
              if (res.is_free_shipping) {
                self.free_shipping_code = code;
              }
            }
            if (res.reapply_global) {
              self.apply_discount(self.global_discount, false, true, false);
            }
            if (!reset) {
              lines = {};
              res.lines.forEach(function(val) {
                return Object.keys(val).forEach(function(id) {
                  return lines[id] = val[id];
                });
              });
              Vue.set(self, 'discount', {
                code: '',
                rate: res.total_discount,
                applied: self.discount.code,
                loading: false,
                error: '',
                lines: lines
              });
              self.get_tax();
            }
          }
        }
      });
    },
    apply_gift: function(code) {
      var self;
      self = this;
      self.gift.loading = true;
      return self.$root.request('/apps/mm-master', {
        module: 'checkout1',
        action: 'gift',
        checkoutId: self.checkoutId,
        discount: code.target ? self.gift.code : code
      }, function(res) {
        var gifts_ids;
        self.gift.loading = false;
        if (res.error) {
          self.gift.error = 'Gift Card number is not valid';
        } else {
          if (res.gifts) {

            /*
            						max = self.order_total + self.gifts_total
            						gifts = []
            						res.gifts.forEach (gift) ->
            							if max > 0
            								if gift.amount > max
            									gift.amount = max
            								gifts.push(gift)
            								max -= gift.amount
            							else
            								gift.amount = 0
            								gifts.push(gift)
             */
            if (self.free_shipping_code) {
              res.gifts.forEach(function(gift, index) {
                return res.gifts[index]['amount'] = gift.amount - self.shipping_price;
              });
            }
            Vue.set(self, 'gifts', res.gifts);
            gifts_ids = {};
            res.gifts.forEach(function(gift) {
              return gifts_ids[gift.id] = self.gift.code;
            });
            Vue.set(self, 'gifts_ids', gifts_ids);
            self.gift.last_code = self.gift.code.toString();
            self.gift.code = '';
            self.get_tax();
          }
        }
      });
    },
    remove_discount: function() {
      var self;
      self = this;
      self.discount.loading = true;
      if (self.discount.applied.toLowerCase() === 'buy2get3') {
        Vue.set(self, 'discount', {
          code: '',
          rate: 0,
          applied: '',
          loading: false,
          error: '',
          lines: []
        });
        return;
      }
      return self.$root.request('/apps/mm-master', {
        module: 'checkout1',
        action: 'discount/remove',
        checkoutId: self.checkoutId,
        global_discount: self.global_discount
      }, function(res) {
        self.is_free_shipping = false;
        self.free_shipping_code = '';
        if (self.global_discount) {
          self.discount.rate = 0;
          self.apply_discount(self.global_discount);
        } else {
          Vue.set(self, 'discount', {
            code: '',
            rate: 0,
            applied: '',
            loading: false,
            error: '',
            lines: []
          });
          self.get_tax();
        }
      });
    },
    remove_gift: function(gift) {
      var self;
      self = this;
      self.discount.loading = true;
      return self.$root.request('/apps/mm-master', {
        module: 'checkout1',
        action: 'gift/remove',
        checkoutId: self.checkoutId,
        giftId: gift.id
      }, function(res) {
        self.discount.loading = false;
        delete self.gifts_ids[gift.id];
        self.gifts.splice(self.gifts.indexOf(gift), 1);
        self.get_tax();
      });
    },
    get_tax: function() {
      var self;
      self = this;
      if (this.discount.applied.substr(-1) === '+') {
        self.tax.rate = 0;
        return self.tax.total = 0;
      } else {
        self.tax.loading = true;
        return self.$root.request('/apps/mm-master', {
          module: 'checkout1',
          action: 'tax',
          checkoutId: self.checkoutId
        }, function(res) {
          var gifts_ids, rate, total_from;
          self.tax.total = res.total_tax;
          self.tax.loading = false;
          total_from = 0;
          self.cart.items.forEach(function(item, i) {
            var d;
            if (item.taxable) {
              d = self.discount.lines[item.variant_id] ? self.discount.lines[item.variant_id] : 0;
              return total_from += item.line_price - d;
            }
          });
          rate = total_from ? self.tax.total / total_from : 0;
          self.tax.rate = rate;
          if (res.gifts) {
            if (self.free_shipping_code) {
              res.gifts.forEach(function(gift, index) {
                return res.gifts[index]['amount'] = gift.amount - self.shipping_price;
              });
            }
            Vue.set(self, 'gifts', res.gifts);
            gifts_ids = {};
            res.gifts.forEach(function(gift) {
              return gifts_ids[gift.id] = self.gift.last_code;
            });
            Vue.set(self, 'gifts_ids', gifts_ids);
          }
          if (document.querySelector('.__items')) {
            return self.$root.stick.height = self.$root.stick.el.parentElement.getBoundingClientRect().height;
          }
        });
      }
    },
    add_sample_product: function(id, group_rate, group_collection) {
      var data, self;
      self = this;
      if (!self.added_samples.includes(id)) {
        self.loading = true;
        data = {
          quantity: 1,
          id: id.toString()
        };
        return self.$root.request('/cart/add.js', data, function(res) {
          self.loading = false;
          self.added_samples.push(id);
          return self.updateCart(group_rate, group_collection);
        });
      }
    },
    updateCart: function(group_rate, group_collection) {
      var prefix, self;
      self = this;
      prefix = lang !== 'en' ? '/' + lang : '';
      return this.$root.request(prefix + '/cart?view=checkout-json', null, function(res) {
        return self.cart = res;
      }, 'GET');
    }
  },
  mounted: function() {
    var checkoutId, def, items, payload, requires_shipping, self, urlParams;
    self = this;
    if (this.cart.items.length === 0) {
      location.href = '/cart';
      return;
    }
    if (this.cart.items.length === 1 && this.cart.items[0].product_type === 'Gift card') {
      this.only_gift = true;
    }
    if (this.cart.items.length === 1 && this.cart.items[0].product_type === 'Season Pass') {
      this.only_virtual = true;
    }

    /*
    		if !@customer.email and (!@only_gift and !@only_virtual)
    			location.href = '/account/login?redirect=checkout'
    			return
     */
    items = this.cart.items.filter(function(obj) {
      return obj.product_type === 'Sample';
    });
    items.forEach(function(item) {
      return self.added_samples.push(item.id);
    });
    requires_shipping = true;
    this.cart.items.forEach(function(item) {
      if (item.properties.Subscription) {
        self.only_one_time = false;
      }
      if (item.requires_shipping) {
        return requires_shipping = false;
      }
    });
    this.only_virtual = requires_shipping;
    this.checked = true;
    def = false;
    urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('reorder')) {
      if (window.reorders[parseInt(urlParams.get('reorder'))]) {
        this.reorder = window.reorders[parseInt(urlParams.get('reorder'))];
      }
    }
    if (urlParams.get('ab')) {
      localStorage.setItem('checkoutId', urlParams.get('ab'));
      this.$root.request('/apps/mm-master', {
        module: 'checkout1',
        action: 'abandoned/click',
        checkoutId: urlParams.get('ab')
      }, function(res) {});
    }
    if (this.addresses) {
      this.addresses.forEach(function(address) {
        var add, found;
        if (self.reorder) {
          add = self.reorder.s ? self.reorder.s : self.reorder.b;
          found = true;
          Object.keys(address).forEach(function(key) {
            if (add[key] != null) {
              if (add[key] !== address[key]) {
                return found = false;
              }
            }
          });
          if (found) {
            if (self.only_virtual) {
              self.customer._saved2 = address.id;
            } else {
              self.customer._saved = address.id;
            }
          }
          if (self.reorder.same) {
            return self.customer.billing_same = true;
          } else {
            found = true;
            Object.keys(address).forEach(function(key) {
              if (self.reorder.b[key] != null) {
                if (self.reorder.b[key] !== address[key]) {
                  return found = false;
                }
              }
            });
            if (found) {
              return self.customer._saved2 = address.id;
            }
          }
        } else {
          if (address["default"]) {
            def = true;
            if (self.only_virtual) {
              return self.customer._saved2 = address.id;
            } else {
              return self.customer._saved = address.id;
            }
          }
        }
      });
    }
    if (!def) {
      if (this.only_virtual) {
        this.customer.billing_address.country = localStorage.getItem('mbcountry');
      } else {
        this.customer.shipping_address.country = localStorage.getItem('mbcountry');
      }
    }
    self = this;
    checkoutId = localStorage.getItem('checkoutId');
    payload = {
      module: 'checkout1',
      action: 'create',
      cid: this.customer.id,
      email: this.customer.email,
      name: this.customer.first_name + ' ' + this.customer.last_name,
      items: this.cart.items.map(function(i) {
        return {
          id: i.variant_id,
          q: i.quantity,
          price: i.customer_price,
          product: {
            id: i.product_id,
            title: i.title,
            handle: i.url.replace('/products/', '').split('?')[0],
            image: i.image
          }
        };
      })
    };
    if (checkoutId) {
      this.checkoutId = checkoutId;
      payload.checkoutId = checkoutId;
      payload.replace = true;
    }
    this.$root.request('/apps/mm-master', payload, function(res) {
      if (!payload.replace) {
        localStorage.setItem('checkoutId', res.id);
        self.checkoutId = res.id;
      } else {
        if (payload.email === "") {
          localStorage.setItem('checkoutId', res.id);
          self.checkoutId = res.id;
        }
      }
      if (self.global_discount && !self.only_gift) {
        self.apply_discount(self.global_discount, false, true);
      }
      setTimeout((function() {
        self.address();
        if (window.noUiSlider !== void 0 && document.querySelector('#RewardsSlider') !== null) {
          self.rewards_slider = document.querySelector('#RewardsSlider');
          noUiSlider.create(self.rewards_slider, {
            range: {
              min: 0,
              max: self.customer._points
            },
            connect: 'lower',
            start: self.customer._points,
            step: 1
          });
          self.rewards_slider.noUiSlider.on('change.one', self.adjust_points_discount);
        }
      }), 1000);
      self.loading = false;
    });
    return this.$root.request('/apps/mm-master', {
      module: 'checkout1',
      action: 'token',
      email: this.customer.email,
      first_name: this.customer.first_name,
      last_name: this.customer.last_name,
      live: this.customer._live
    }, function(res) {
      self.tokenized = true;
      return braintree.dropin.create({
        authorization: res.token,
        selector: '#dropin',
        locale: lang === 'fr' ? 'fr_FR' : 'en_US',
        vaultManager: true,
        paypal: {
          flow: 'checkout',
          amount: cart.total_price / 100,
          currency: currency
        },
        card: {
          cardholderName: {
            required: true
          },
          vault: {
            allowVaultCardOverride: true
          }
        }
      }, function(err, instance) {
        if (err) {
          console.error(err);
          return;
        }
        self.dropinstance = instance;
        instance.on('paymentMethodRequestable', function(e) {
          if (e.paymentMethodIsSelected && e.type.indexOf('PayPal') > -1) {
            return instance.requestPaymentMethod(function(requestPaymentMethodErr, payload) {
              if (!requestPaymentMethodErr) {
                return self.order(payload.nonce, 'paypal');
              }
            });
          }
        });
        document.querySelector('#pay').addEventListener('click', function() {
          if (self.order_total > 0) {
            return instance.requestPaymentMethod(function(requestPaymentMethodErr, payload) {
              if (!requestPaymentMethodErr) {
                grecaptcha.ready(function() {});
                return grecaptcha.execute('6LdVZtwpAAAAAKEQJY2oMnoNN-Iq0WnHvODHWLEa', {
                  action: 'submit'
                }).then(function(token) {
                  return fetch("https://recaptcha-verify.developers-efd.workers.dev/?x-shop-domain=maisonbeljanski.com&x-token=" + token).then(function(response) {
                    if (response.ok) {
                      return response.json().then(function(data) {
                        if (data.score > 0.1) {
                          return self.order(payload.nonce, 'card');
                        }
                      });
                    }
                  })["catch"](function(error) {
                    return console.error(error);
                  });
                });
              } else {
                self.error = lang === 'en' ? 'Required fields are empty or are invalid' : 'Les champs obligatoires sont vides ou invalides';
                return self.$validator.validate();
              }
            });
          } else {
            return self.order(null, 'free');
          }
        });
        if (document.querySelector('.__items')) {
          return self.$root.stick.height = self.$root.stick.el.parentElement.getBoundingClientRect().height;
        }
      });
    });

    /*
    		@$nextTick ->
    			autocomplete = new google.maps.places.Autocomplete @$refs.address1,
    				fields: ['address_components']
    				types: ['address']
    
    			fillInAddress = ->
    				place = autocomplete.getPlace()
    				address = ''
    				place.address_components.forEach (p) ->
    					if p.types.indexOf('street_number') != -1
    						address += p.long_name + ' '
    					if p.types.indexOf('route') != -1
    						address += p.long_name + ' '
    					if p.types.indexOf('locality') != -1
    						self.customer.shipping_address.city = p.long_name
    					if p.types.indexOf('postal_code') != -1
    						self.customer.shipping_address.zip = p.long_name
    					if p.types.indexOf('country') != -1
    						self.customer.shipping_address.country = p.long_name
    
    					if p.types.indexOf('administrative_area_level_1') != -1
    						setTimeout(->
    							self.customer.shipping_address.province = p.long_name
    						, 100)
    
    				if address != ''
    					self.customer.shipping_address.address1 = address
    
    			autocomplete.addListener 'place_changed', fillInAddress
    
    			autocomplete2 = new google.maps.places.Autocomplete @$refs.address2,
    				fields: ['address_components']
    				types: ['address']
    
    			fillInAddress2 = ->
    				place = autocomplete2.getPlace()
    				address = ''
    				place.address_components.forEach (p) ->
    					if p.types.indexOf('street_number') != -1
    						address += p.long_name + ' '
    					if p.types.indexOf('route') != -1
    						address += p.long_name + ' '
    					if p.types.indexOf('locality') != -1
    						self.customer.billing_address.city = p.long_name
    					if p.types.indexOf('postal_code') != -1
    						self.customer.billing_address.zip = p.long_name
    					if p.types.indexOf('country') != -1
    						self.customer.billing_address.country = p.long_name
    
    					if p.types.indexOf('administrative_area_level_1') != -1
    						setTimeout(->
    							self.customer.billing_address.province = p.long_name
    						, 100)
    
    				if address != ''
    					self.customer.billing_address.address1 = address
    
    			autocomplete2.addListener 'place_changed', fillInAddress2
     */
  }
};


},{}],16:[function(require,module,exports){
module.exports = {
  data: function() {
    return {
      filter: '*'
    };
  }
};


},{}],17:[function(require,module,exports){
module.exports = {
  data: function() {
    return {
      pass: '',
      pass2: '',
      match: true,
      newsletter: false,
      affiliate: false,
      pro: 'No',
      specs1: '',
      specs2: [],
      tags: 'Language::' + window.lang.toUpperCase() + ',' + 'Group::General',
      email: '',
      country: '',
      province: ''
    };
  },
  watch: {
    affiliate: function() {
      return this.updateTags();
    },
    pro: function() {
      return this.updateTags();
    },
    specs1: function() {
      return this.updateTags();
    },
    specs2: function() {
      return this.updateTags();
    },
    country: function(val) {
      var self;
      self = this;
      return this.$nextTick(function() {
        var option, provinces, provinces_html;
        option = self.$refs.shipping_country.querySelector('[value="' + val + '"]');
        if (!option || option.dataset.provinces === '[]') {
          return self.province = '';
        } else {
          provinces = JSON.parse('[' + option.dataset.provinces + ']');
          provinces_html = '';
          provinces = provinces.filter(function(p) {
            return blacklist.indexOf(p[1]) === -1;
          });
          provinces.forEach(function(p) {
            return provinces_html += '<option value="' + p[1] + '">' + p[1] + '</option>';
          });
          self.$refs.shipping_province.innerHTML = provinces_html;
          return self.province = provinces[0][1];
        }
      });
    }
  },
  mounted: function() {
    var loginForm, self, url;
    self = this;
    loginForm = document.querySelector('#customer_login');
    if (loginForm) {
      loginForm.addEventListener('submit', function() {
        return localStorage.setItem('mbemail', self.email);
      });
    }
    if (window.location.hash === '#recover' || document.querySelector('#reset_success')) {
      this.$root.forgottenPopup = true;
    }
    if (window.location.search.indexOf('welcome') > -1 && !document.querySelector('form .errors')) {
      url = window.lang === 'fr' ? '/fr' : '/';
      if (window.location.search.indexOf('redirect') > -1) {
        url = window.lang === 'fr' ? '/fr/pages/checkout' : '/pages/checkout';
      }
      window.location = url;
    }
    if (window.location.search.indexOf('redirect') > -1) {
      return document.querySelector('#create_customer [name="return_to"]').value += '&redirect=checkout';
    }
  },
  methods: {
    checkPass: function() {
      return this.match = this.pass === this.pass2;
    },
    updateTags: function() {
      var tags;
      tags = ['Language::' + window.lang.toUpperCase(), 'Group::General'];
      if (this.affiliate) {
        tags.push('Interest::Affiliate');
      }
      if (this.newsletter) {
        tags.push('Interest::Newsletter');
      }
      if (this.pro === 'Yes') {
        tags.push('Interest::Pro');
        if (this.specs1 !== '') {
          tags.push('Speciality::' + this.specs1);
        }
        if (this.specs2.length > 0) {
          this.specs2.forEach(function(s) {
            return tags.push('Specialities::' + s);
          });
        }
      }
      return this.tags = tags.join(',');
    }
  },
  components: {
    check: {
      props: ['default'],
      data: function() {
        return {
          error: ''
        };
      },
      mounted: function() {
        var data, mbemail, self;
        self = this;
        mbemail = localStorage.getItem('mbemail');
        data = {
          module: 'beljanski',
          action: 'check',
          email: mbemail
        };
        return this.$root.request('/apps/mm-master', data, function(res) {
          if (res.error === 'default') {
            document.querySelector('.account-form .errors').style.display = 'block';
            self.error = self["default"];
          } else {

            /*
            						if lang == 'fr'
            							self.error = 'UN E-MAIL A ÉTÉ ENVOYÉ À ' + mbemail + ' VEUILLEZ CLIQUER SUR LE LIEN CONTENU DANS LE E-MAIL POUR CONFIRMER VOTRE ADRESSE.'
            						else
            							self.error = 'WE HAVE SENT AN EMAIL TO ' + mbemail + ', PLEASE CLICK THE LINK INCLUDED TO VERIFY YOUR EMAIL ADDRESS.'
             */
            self.$root.welcomePopup = true;
            data = {
              module: 'beljanski',
              action: 'activate',
              email: mbemail
            };
            self.$root.request('/apps/mm-master', data, function(res) {});
          }
          return localStorage.removeItem('mbemail');
        });
      }
    }
  }
};


},{}],18:[function(require,module,exports){
module.exports = {
  props: ['id', 'oname', 'email', 'first_name', 'last_name', 'total', 'currency'],
  data: function() {
    return {
      ordering: false,
      error: '',
      error_payment: false,
      tokenized: false
    };
  },
  methods: {
    order: function(nonce, type) {
      var self;
      self = this;
      self.error = '';
      self.error_payment = false;
      self.ordering = true;
      return self.$root.request('/apps/mm-master', {
        module: 'checkout1',
        action: 'pay2',
        nonce: nonce,
        type: type,
        live: false,
        order_id: self.id,
        order_name: self.oname,
        d: JSON.stringify({
          email: self.email,
          first_name: self.first_name,
          last_name: self.last_name,
          currency: self.currency
        })
      }, function(res) {
        if (res.error) {
          if (res.error === 403) {
            self.error = lang === 'fr' ? 'Payment refusé' : 'Card was declined';
            self.error_payment = true;
          } else {
            self.error = window.errors_t[res.message.trim()] ? window.errors_t[res.message.trim()] : res.message;
          }
          self.ordering = false;
        } else {
          location.reload();
        }
      });
    }
  },
  mounted: function() {
    var self;
    self = this;
    return this.$root.request('/apps/mm-master', {
      module: 'checkout1',
      action: 'token',
      email: this.email,
      first_name: this.first_name,
      last_name: this.last_name,
      live: false
    }, function(res) {
      self.tokenized = true;
      return braintree.dropin.create({
        authorization: res.token,
        selector: '#dropin',
        locale: lang === 'fr' ? 'fr_FR' : 'en_US',
        vaultManager: true,
        paypal: {
          flow: 'checkout',
          amount: self.total / 100,
          currency: currency
        },
        card: {
          cardholderName: {
            required: true
          },
          vault: {
            allowVaultCardOverride: true
          }
        }
      }, function(err, instance) {
        if (err) {
          console.error(err);
          return;
        }
        self.dropinstance = instance;
        instance.on('paymentMethodRequestable', function(e) {
          if (e.paymentMethodIsSelected && e.type.indexOf('PayPal') > -1) {
            return instance.requestPaymentMethod(function(requestPaymentMethodErr, payload) {
              if (!requestPaymentMethodErr) {
                return self.order(payload.nonce, 'paypal');
              }
            });
          }
        });
        return document.querySelector('#pay').addEventListener('click', function() {
          return instance.requestPaymentMethod(function(requestPaymentMethodErr, payload) {
            if (!requestPaymentMethodErr) {
              console.log(self.order);
              return self.order(payload.nonce, 'card');
            }
          });
        });
      });
    });
  }
};


},{}],19:[function(require,module,exports){
module.exports = {
  props: ['id', 'max', 'preorder', 'restricted', 'title', 'handle'],
  data: function() {
    return {
      slider: null,
      q: 1,
      pid: this.id,
      pmax: this.max ? parseInt(this.max) : 9999,
      option1: '',
      option2: '',
      option3: '',
      status: 'Add to cart',
      bundle_items: bundleItems,
      coaching: null,
      individual: null,
      group: null,
      ostatus: null,
      purchase: 'one',
      submodel: '30',
      showSubscriptionModal: false,
      isSubscriptionConfirmed: false
    };
  },
  watch: {
    coaching: function(val) {
      var option, option1;
      option1 = val === 'individual' ? this.individual : this.group;
      option = document.querySelector('[data-option-1="' + option1 + '"][data-option-2="' + this.option2 + '"][data-option-3="' + this.option3 + '"]');
      if (option) {
        return this.selectOption(1, option1, null);
      }
    }
  },
  methods: {
    plus: function() {
      if (this.q < this.pmax) {
        this.q++;
        return document.querySelector('.add-to-cart.fixed .val').innerText = this.q;
      }
    },
    minus: function() {
      if (this.q > 1) {
        this.q--;
        return document.querySelector('.add-to-cart.fixed .val').innerText = this.q;
      }
    },
    selectOption: function(index, val, e) {
      var option, self;
      self = this;
      if (e && e.target.closest('.selector')) {
        e.target.closest('.selector').classList.remove('open');
      }
      this['option' + index] = val;
      option = document.querySelector('[data-option-1="' + this.option1 + '"][data-option-2="' + this.option2 + '"][data-option-3="' + this.option3 + '"]');
      if (option) {
        this.pmax = parseInt(option.dataset.max);
        if (this.pmax === 0) {
          this.status = 'Out of stock';
        } else {
          this.status = 'Add to cart';
          if (this.q > this.pmax) {
            this.q = this.pmax;
          }
        }
        this.pid = option.value;
        document.querySelectorAll('section.product .price').forEach(function(el) {
          var prefix;
          prefix = '';
          if (self.$root.global.discount !== '') {
            if (self.restricted.indexOf(self.$root.global.restrict) > -1) {
              prefix = '<em>' + Shopify.formatMoney(option.dataset.price * self.$root.global.rate) + '</em>';
            }
          }
          return el.innerHTML = prefix + '<span>' + Shopify.formatMoney(option.dataset.price) + '</span>';
        });
        if (option.innerText.indexOf('@') === -1) {
          this.individual = val;
        } else {
          this.group = val;
        }
        if (option.dataset.image) {
          return this.slider.goTo(document.querySelector('.slide[data-image="' + option.dataset.image + '"]').dataset.slideId);
        }
      }
    },
    closeSubscriptionModal: function() {
      this.showSubscriptionModal = false;
      return this.isSubscriptionConfirmed = false;
    },
    confirmSubscription: function() {
      if (this.purchase === 'subscription') {
        if (window.Scrollbar.has(document.querySelector('div.scroll-wrapper.scrolls'))) {
          window.Scrollbar.destroy(document.querySelector('div.scroll-wrapper.scrolls'));
        }
        return this.showSubscriptionModal = true;
      } else {
        return this.add();
      }
    },
    add: function() {
      var items, properties, self;
      this.closeSubscriptionModal();
      if (this.bundle_items.length) {
        self = this;
        properties = {};
        properties['BundleID'] = Math.floor(Date.now() / 1000);
        properties['BundleKit'] = this.title;
        properties['Handle'] = this.handle;
        if (this.preorder) {
          properties['Pre-order'] = 'Yes';
        } else if (this.purchase !== 'one') {
          properties['Subscription'] = this.submodel;
        }
        items = [];
        this.bundle_items.forEach(function(vid) {
          return items.push({
            id: vid,
            quantity: self.q,
            properties: properties
          });
        });
        return this.$root.addToCart({
          items: items
        });
      } else {
        if (this.preorder) {
          return this.$root.addToCart({
            quantity: this.q,
            id: this.pid,
            properties: {
              'Pre-order': 'Yes'
            }
          });
        } else if (this.purchase !== 'one') {
          properties = {};
          properties['Subscription'] = this.submodel;
          if (currency === 'USD') {
            properties['Market'] = 'US';
          }
          return this.$root.addToCart({
            quantity: this.q,
            id: this.pid,
            properties: properties
          });
        } else {
          return this.$root.addToCart({
            quantity: this.q,
            id: this.pid
          });
        }
      }
    },
    out_stock_notify: function(e) {
      var self;
      self = this;
      if (this.$refs.honeypot.value === '') {
        return this.$validator.validate().then(function(res) {
          var data;
          if (res) {
            self.ostatus = 'sending';
            data = {
              form: self.$root.formalize(e.target)
            };
            return self.$root.request('https://mb.minionmade.net/forms?shop=staging1-mb.myshopify.com', data, function(res) {
              return self.ostatus = 'sent';
            });
          }
        });
      }
    }
  },
  mounted: function() {
    var self;
    self = this;
    this.slider = tns({
      container: this.$refs.slider,
      autoHeight: true,
      controls: false,
      nav: false,
      speed: 500,
      mode: 'gallery'
    });
    if (this.$refs.nav) {
      this.sliderNav = tns({
        container: this.$refs.nav,
        controls: true,
        nav: false,
        speed: 500,
        items: 3,
        axis: 'vertical'
      });
      this.sliderNavMobile = tns({
        container: this.$refs.nav2,
        controls: true,
        nav: false,
        speed: 500,
        items: 3,
        axis: 'horizontal',
        responsive: {
          768: {
            items: 4
          }
        }
      });
    }
    refreshFsLightbox();
    if (this.id) {
      if (this.pmax === 0) {
        this.status = 'Out of stock';
      }
    } else {
      this.status = 'Select variant';
    }
    return document.body.addEventListener('click', function(e) {
      if (e.target.href) {
        if (e.target.href.indexOf('#individual') > -1) {
          e.preventDefault();
          self.coaching = 'individual';
          self.$root.scroll('.add-to-cart');
        }
        if (e.target.href.indexOf('#group') > -1) {
          e.preventDefault();
          self.coaching = 'group';
          self.$root.scroll('.add-to-cart');
        }
      }
      if (e.target.dataset.go) {
        e.preventDefault();
        return self.slider.goTo(e.target.dataset.go);
      }
    });
  }
};


},{}],20:[function(require,module,exports){
module.exports = {
  props: ['id', 'second_id'],
  data: function() {
    return {
      status: '',
      open: false,
      sort: 'highest-rating',
      rate: 4,
      rate_selected: 5,
      list: [],
      freq: null,
      max: 5
    };
  },
  computed: {
    reviews: function() {
      var self;
      self = this;
      if (this.sort === 'most-recent') {
        this.list.sort(function(a, b) {
          return new Date(b.created_at) - (new Date(a.created_at));
        });
      }
      if (this.sort === 'highest-rating') {
        this.list.sort(function(a, b) {
          return parseInt(b.form.score) - (parseInt(a.form.score));
        });
      }
      if (this.freq) {
        return this.list.filter(function(a) {
          return a.form.score === self.freq;
        });
      } else {
        return this.list;
      }
    },
    score: function() {
      var sum;
      sum = 0;
      this.list.forEach(function(review) {
        return sum += parseInt(review.form.score);
      });
      if (sum > 0) {
        return sum / this.list.length;
      } else {
        return 0;
      }
    },
    totals: function() {
      var self, totals;
      self = this;
      totals = {
        '5': {
          count: 0,
          percentage: 0
        },
        '4': {
          count: 0,
          percentage: 0
        },
        '3': {
          count: 0,
          percentage: 0
        },
        '2': {
          count: 0,
          percentage: 0
        },
        '1': {
          count: 0,
          percentage: 0
        }
      };
      this.list.forEach(function(review) {
        return totals[review.form.score].count++;
      });
      Object.keys(totals).forEach(function(key) {
        return totals[key].percentage = self.list.length ? Math.round(totals[key].count / self.list.length * 100) : 0;
      });
      return totals;
    }
  },
  methods: {
    submit: function(e) {
      var data, self;
      e.preventDefault();
      self = this;
      if (this.$refs.honeypot.value === '') {
        this.status = 'sending';
        data = {
          form: self.$root.formalize(e.target)
        };
        return self.$root.request('https://mb.minionmade.net/forms?shop=staging1-mb.myshopify.com', data, function(res) {
          return self.status = 'sent';
        });
      }
    },
    changeFreq: function(f) {
      return this.freq = f === this.freq ? null : f;
    }
  },
  mounted: function() {
    var data, self;
    self = this;
    data = {
      module: 'beljanski',
      action: 'reviews',
      id: this.id
    };
    return this.$root.request('/apps/mm-master', data, function(res) {
      var temp;
      if (self.second_id) {
        temp = res;
        data.id = self.second_id;
        return self.$root.request('/apps/mm-master', data, function(res2) {
          return Vue.set(self, 'list', temp.concat(res2));
        });
      } else {
        return Vue.set(self, 'list', res);
      }
    });
  }
};


},{}],21:[function(require,module,exports){
module.exports = {
  props: ['products'],
  data: function() {
    return {
      pros: [],
      status: ''
    };
  },
  methods: {
    submit: function(e) {
      var data, self;
      e.preventDefault();
      self = this;
      if (this.$refs.honeypot.value === '') {
        this.status = 'sending';
        data = {
          form: self.$root.formalize(e.target)
        };
        return self.$root.request('https://mb.minionmade.net/forms?shop=staging1-mb.myshopify.com', data, function(res) {
          return self.status = 'sent';
        });
      }
    }
  },
  mounted: function() {
    return this.pros = JSON.parse(this.products);
  },
  components: {
    review: {
      props: ['product'],
      data: function() {
        return {
          rate: 5,
          rate_selected: 5
        };
      }
    }
  }
};


},{}],22:[function(require,module,exports){
module.exports = {
  props: ['customer'],
  data: function() {
    return {
      page: 1,
      list: [],
      loading: false
    };
  },
  methods: {
    load: function() {
      var data, self;
      self = this;
      this.loading = true;
      data = {
        module: 'beljanski',
        action: 'points',
        page: this.page,
        customer: this.customer
      };
      return this.$root.request('/apps/mm-master', data, function(res) {
        Vue.set(self, 'list', res);
        return self.loading = false;
      });
    },
    prev: function() {
      this.page--;
      return this.load();
    },
    next: function() {
      this.page++;
      return this.load();
    }
  },
  mounted: function() {
    return this.load();
  }
};


},{}],23:[function(require,module,exports){
module.exports = {
  mounted: function() {
    var params;
    if (window.location.search.indexOf('sort_by') !== -1) {
      params = new URLSearchParams(window.location.search);
      return this.$el.innerHTML = document.querySelector('[href="?sort_by=' + params.get('sort_by') + '"]').innerHTML;
    }
  }
};


},{}],24:[function(require,module,exports){
module.exports = {
  props: ['customer', 'email'],
  data: function() {
    return {
      loading: true,
      list: [],
      payment: null,
      modals: {
        cancel: null
      },
      customerId: null
    };
  },
  methods: {
    load: function() {
      var data, self;
      self = this;
      this.loading = true;
      data = {
        module: 'checkout1',
        action: 'subscriptions/get',
        customer: this.customer,
        email: this.email
      };
      return this.$root.request('/apps/mm-master', data, function(res) {
        Vue.set(self, 'list', res.list);
        Vue.set(self, 'payment', res.payment);
        Vue.set(self, 'customerId', res.customerId);
        return self.loading = false;
      });
    },
    cancelSubscription: function() {
      var data, self;
      self = this;
      data = {
        module: 'checkout1',
        action: 'subscriptions/status',
        _id: this.modals.cancel,
        active: false
      };
      this.$root.request('/apps/mm-master', data, function(res) {});
      this.list.forEach(function(sub) {
        if (sub._id.$oid === self.modals.cancel.$oid) {
          return sub.active = false;
        }
      });
      return this.modals.cancel = null;
    },
    activateSubscription: function(el) {
      var data, self;
      self = this;
      this.loading = true;
      data = {
        module: 'checkout1',
        action: 'subscriptions/status',
        _id: el._id,
        active: true,
        freq: el.plan.freq
      };
      return this.$root.request('/apps/mm-master', data, function(res) {
        return self.load();
      });
    },
    editAddress: function(el) {
      var address;
      address = JSON.parse(JSON.stringify(el.order.shipping_address));
      address.subscription = el._id;
      address.customer_id = el.customer.id;
      address.loading = false;
      this.$root.addressPopup = address;
      return setTimeout(function() {
        return new Shopify.CountryProvinceSelector('AddressCountry_SUB', 'AddressProvince_SUB', {
          hideElement: 'AddressProvinceContainer_SUB'
        });
      }, 10);
    },
    editSkip: function(el) {
      var data;
      data = JSON.parse(JSON.stringify(el));
      data.type = 'none';
      data.date = new Date(el.plan.next);
      data.loading = false;
      return this.$root.skipPopup = data;
    },
    editPayment: function() {
      return this.$root.paymentPopup = {
        loading: false
      };
    },
    savePayment: function(nonce) {
      var self;
      self = this;
      return this.$root.request('/apps/mm-master', {
        module: 'checkout1',
        action: 'subscriptions/payment',
        nonce: nonce,
        customerId: this.customerId
      }, function(res) {
        if (res.error) {
          alert(res.message);
          return self.$root.paymentPopup = {
            loading: false
          };
        } else {
          Vue.set(self, 'payment', res.payment);
          return self.$root.paymentPopup = null;
        }
      });
    }
  },
  mounted: function() {
    var self;
    self = this;
    this.load();
    return this.$root.request('/apps/mm-master', {
      module: 'checkout1',
      action: 'token',
      email: customer_data.email,
      first_name: customer_data.first_name,
      last_name: customer_data.last_name
    }, function(res) {
      return braintree.dropin.create({
        authorization: res.token,
        selector: '#dropin',
        locale: lang === 'fr' ? 'fr_FR' : 'en_US',
        vaultManager: true,
        paypal: {
          flow: 'vault'
        },
        card: {
          cardholderName: {
            required: true
          }
        }
      }, function(err, instance) {
        if (err) {
          console.error(err);
          return;
        }
        instance.on('paymentMethodRequestable', function(e) {
          if (e.paymentMethodIsSelected && e.type.indexOf('PayPal') > -1) {
            return instance.requestPaymentMethod(function(requestPaymentMethodErr, payload) {
              if (!requestPaymentMethodErr) {
                self.$root.paymentPopup.loading = true;
                return self.savePayment(payload.nonce);
              }
            });
          }
        });
        return document.querySelector('#subpay').addEventListener('click', function() {
          return instance.requestPaymentMethod(function(requestPaymentMethodErr, payload) {
            if (!requestPaymentMethodErr) {
              self.$root.paymentPopup.loading = true;
              return self.savePayment(payload.nonce);
            }
          });
        });
      });
    });
  }
};


},{}]},{},[2])